<template>
  <div class="secretary-call" v-if="secretaryName || secretaryPhone">
    <a
      v-if="!isPC && telHref"
      class="secretary"
      :href="telHref"
    >
      <img src="@images/expertTask/secretary-phone.png" alt />
      <span>{{ secretaryLabel }}</span>
    </a>
    <div v-else class="secretary" @click="onClickSecretary">
      <img src="@images/expertTask/secretary-phone.png" alt />
      <span>{{ secretaryLabel }}</span>
    </div>
    <van-dialog
      v-model="secretaryShow"
      :show-cancel-button="false"
      confirmButtonText="关闭"
      confirmButtonColor="#0089FF"
      :closeOnClickOverlay="true"
    >
      <div class="secretary-dialog">
        <div class="secretary-dialog-title">专属小秘书</div>
        <div class="secretary-dialog-row" v-if="secretaryName">
          姓名：{{ secretaryName }}
        </div>
        <a
          v-if="telHref"
          class="secretary-dialog-row secretary-dialog-phone"
          :href="telHref"
        >
          电话：{{ secretaryPhone }}
        </a>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from '@utils/vuex'
import os from '@utils/os'

export default {
  name: 'SecretaryCall',
  computed: {
    ...mapState('expertTaskList', ['secretaryName', 'secretaryPhone']),
    isPC() {
      return os.isPC()
    },
    secretaryLabel() {
      return this.secretaryName ? `专属小秘书-${this.secretaryName}` : '专属小秘书'
    },
    telHref() {
      const phone = String(this.secretaryPhone || '').replace(/[^\d+]/g, '')
      return phone ? `tel:${phone}` : ''
    }
  },
  data() {
    return {
      secretaryShow: false
    }
  },
  methods: {
    onClickSecretary() {
      if (!this.secretaryPhone) {
        this.$toast('暂无联系电话')
        return
      }
      this.secretaryShow = true
    }
  }
}
</script>

<style scoped lang="scss">
.secretary-call {
  margin-left: auto;
  margin-right: auto;
  flex: 1;
  max-width: 12em;
  overflow: hidden;
}
.secretary {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  img {
    width: .682667rem;
    height: .682667rem;
    margin-right: 0.16rem;
    flex-shrink: 0;
  }
  span {
    font-size: .597333rem;
    line-height: .810667rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.secretary-dialog {
  padding: 0.6rem;
  box-sizing: border-box;
  text-align: center;
}
.secretary-dialog-title {
  font-size: 0.58rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 0.32rem;
}
.secretary-dialog-row {
  font-size: 0.5rem;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.75);
}
.secretary-dialog-phone {
  display: block;
  color: #0089ff;
  cursor: pointer;
  text-decoration: none;
}
</style>
